/** Field keys shared by validateOrder and the UI, so an error lands next to its field (same keys as OrderFields.cs). */
export const F = {
  orderDate: 'OrderDate',
  participantName: 'ParticipantName',
  memberNumber: 'MemberNumber',
  center: 'Center',
  birthYear: 'BirthYear',
  pupillaryDistance: 'PupillaryDistance',
  rxUploadedToEmr: 'RxUploadedToEmr',
  frames: 'Frames',
  clipOn: 'ClipOn',
  add: 'Add',
  lensType: 'LensType',
  frame: (id: string): string => `Frame:${id}`,
  eye: (eye: 'Od' | 'Os', part: string): string => `${eye}.${part}`,
} as const
